import React from 'react'

import { getInclusionIcon } from 'lib/getInclusionIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import StructureLabel from 'components/Luxkit/Label/StructureLabel'
import BodyText from 'components/Luxkit/Typography/BodyText'

import styled from 'styled-components'

import { rem } from 'polished'
import { convertMarkdownInclusionsToArray } from 'lib/markdownUtil'

const Stack = styled.div`
  & > * + * {
    margin-top: ${rem(8)}
  }

  &.md {
    & > * + * {
      margin-top: ${rem(12)}
    }
  }
`

function renderInclusions(bonusInclusions: App.PackageInclusion[], inclusions: App.PackageInclusion[]) {
  const hasInclusions = inclusions?.length > 0
  const hasBonusInclusions = bonusInclusions?.length > 0

  const hasInclusionsV2 = inclusions && inclusions.length > 0 && inclusions.some(i => i.descriptionV2List)
  // bonus inclusions are pre-mapped to descriptionV2
  const hasBonusInclusionsV2 = bonusInclusions && bonusInclusions.length > 0 && bonusInclusions.some(i => i.descriptionV2List)

  const hasAnyInclusions = hasInclusions || hasBonusInclusions || hasInclusionsV2 || hasBonusInclusionsV2

  if (hasAnyInclusions) {
    return (
      <Stack className="md">
        {(hasBonusInclusions || hasBonusInclusionsV2) && (
          <Stack>
            <StructureLabel variant="premium">BONUS inclusions:</StructureLabel>
            {bonusInclusions.map((bonusInclusion) => {
              if ((bonusInclusion?.descriptionV2List?.length ?? 0) > 0) {
                return bonusInclusion.descriptionV2List.map((inclusionV2) => {
                  const InclusionIcon = getInclusionIcon(inclusionV2?.icon || '')
                  return (
                    <BodyTextBlock
                      variant="medium"
                      weight={inclusionV2.isHighlighted ? 'bold' : 'normal'}
                      startIcon={<InclusionIcon colour={inclusionV2.isHighlighted ? 'secondary-normal' : undefined}/>}
                      key={inclusionV2.text}>
                      {inclusionV2.text}
                    </BodyTextBlock>
                  )
                })
              } else {
                const InclusionIcon = getInclusionIcon(bonusInclusion?.categoryIcon || '')
                const description = bonusInclusion?.description?.startsWith('-') ?
                  bonusInclusion?.description?.slice(1).trim() :
                  bonusInclusion.description

                const descriptionLines = description ? convertMarkdownInclusionsToArray(description) : []

                return (
                  <>
                    {descriptionLines.map((line, index) => (
                      <BodyTextBlock
                        variant="medium"
                        weight="normal"
                        startIcon={<InclusionIcon />}
                        key={`${description}-${index}`}
                      >
                        {line}
                      </BodyTextBlock>
                    ))}
                  </>
                )
              }
            })}
          </Stack>
        )}
        {hasInclusions && (
          <div>
            {(hasBonusInclusions || hasBonusInclusionsV2) && (
              <BodyText variant="large" weight="bold">
                You also get:
              </BodyText>
            )}
            {inclusions.map((inclusion) => {
              if ((inclusion?.descriptionV2List?.length ?? 0) > 0) {
                return inclusion.descriptionV2List.map((inclusionV2) => {
                  const InclusionIcon = getInclusionIcon(inclusionV2?.icon || '')
                  return (
                    <BodyTextBlock variant="medium"
                      weight={inclusionV2.isHighlighted ? 'bold' : 'normal'}
                      startIcon={<InclusionIcon colour={inclusionV2.isHighlighted ? 'secondary-normal' : undefined}/>}
                      key={inclusionV2.text}>
                      {inclusionV2.text}
                    </BodyTextBlock>
                  )
                })
              } else {
                const InclusionIcon = getInclusionIcon(inclusion?.categoryIcon || '')
                const description = inclusion?.description?.startsWith('-') ?
                  inclusion?.description?.slice(1).trim() :
                  inclusion.description

                const descriptionLines = description ? convertMarkdownInclusionsToArray(description) : []

                return (
                  <>
                    {descriptionLines.map((line, index) => (
                      <BodyTextBlock
                        variant="medium"
                        weight="normal"
                        startIcon={<InclusionIcon />}
                        key={`${description}-${index}`}
                      >
                        {line}
                      </BodyTextBlock>
                    ))}
                  </>
                )
              }
            })}
          </div>
        )}
      </Stack>
    )
  }

  return null
}

export default renderInclusions
